import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Sparkles, ChevronDown, ChevronUp } from "lucide-react";

/**
 * Neon notice at the top of the ProductModal right-hand form panel.
 * Collapsible so users who don't need it can hide the message body
 * while keeping the pill visible for reference.
 */
export default function ModalCustomNotice() {
  const [open, setOpen] = useState(true);

  return (
    <div
      data-testid="modal-custom-notice"
      className="mb-6 rounded-md border border-[#c6a87c] bg-[#0a0a0c] p-4 text-white"
      style={{
        animation: "neon-pulse-static 3.4s ease-in-out infinite",
      }}
    >
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        data-testid="modal-custom-notice-toggle"
        aria-expanded={open}
        className="flex w-full items-center justify-between gap-3"
      >
        <span className="flex items-center gap-2">
          <Sparkles size={13} className="text-[#c6a87c]" strokeWidth={1.8} />
          <span
            className="font-tech text-[10px] font-bold uppercase tracking-[0.28em] text-[#c6a87c]"
            style={{
              textShadow:
                "0 0 6px rgba(198,168,124,0.85), 0 0 12px rgba(198,168,124,0.5)",
            }}
          >
            Need Further Customization?
          </span>
        </span>
        <span className="text-[#c6a87c]">
          {open ? <ChevronUp size={14} /> : <ChevronDown size={14} />}
        </span>
      </button>

      <AnimatePresence initial={false}>
        {open && (
          <motion.div
            key="body"
            initial={{ height: 0, opacity: 0 }}
            animate={{ height: "auto", opacity: 1 }}
            exit={{ height: 0, opacity: 0 }}
            transition={{ duration: 0.35, ease: [0.19, 1, 0.22, 1] }}
            className="overflow-hidden"
          >
            <p className="mt-3 font-body text-[12.5px] leading-[1.65] text-white/75">
              We can do custom design configurations, bespoke sizes, feature
              hardware and one-off finishes. Email the studio directly.
            </p>
            <a
              href="mailto:orders@euro-steel.co.nz?subject=Custom%20Design%20Enquiry"
              data-testid="modal-custom-notice-email"
              className="mt-3 inline-flex items-center gap-2 rounded-full bg-[#c6a87c] px-4 py-2 font-tech text-[10px] font-semibold uppercase tracking-[0.24em] text-[#0a0a0c] transition-colors hover:bg-[#d8bd93]"
            >
              orders@euro-steel.co.nz
            </a>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
